import { browser } from "$lib/core/js/util/env";
import { globals } from "$lib/ui-core";
import { Logger } from "$lib/core/js/util/logger";
export const trustedTypesLogger = new Logger("trustedTypes");

/**
 * 
 * @returns {import("./defs").TrustedTypePolicy}
 */
function createTrustedTypePolicy() {
	/** @type {(input: string) => string} */
	const createHTML = (input) => input;

	/** @type {(input: string) => string} */
	const createScript = (input) => input;

	/** @type {(input: string) => string} */
	const createScriptURL = (input) => input;

	/**
	 * @returns {string}
	 */
	function getTrustedTypePolicyName() {
		if (!browser) return "default";
		const html = document.querySelector("html") ?? document.documentElement;
		let policyName = "default";
		const altPolicyName = html?.getAttribute("data-tt-policy");
		if (!!altPolicyName) {
				policyName = altPolicyName;
		}
		return policyName;
	}

	const policyName = getTrustedTypePolicyName();

	// @ts-ignore
	if (browser && globals.trustedTypes) {
		/** @type {import("./defs").TrustedTypePolicy} */
		// @ts-ignore
		const policy = globals.trustedTypes.createPolicy(policyName, {
			createHTML,
			createScript,
			createScriptURL,
		});
		if (policy) {
			trustedTypesLogger.info(`Baylor UI using Trusted Type Policy: '${policyName}'`);
		} else {
			trustedTypesLogger.error(`Baylor UI failed create a policy from the TrustedTypePolicyFactory: '${policyName}'`);
		}
		return policy;
	} else {
		trustedTypesLogger.info(`Page has no TrustedTypePolicyFactory. Baylor UI constructing mock Trusted Type Policy: '${policyName}'`);
		/** @type {import("./defs").TrustedTypePolicy} */
		const obj = {
			createHTML,
			createScript,
			createScriptURL,
		}
		return obj;
	}
}

/** @type {import("./defs").TrustedTypePolicy} */
// @ts-ignore
export const policy = createTrustedTypePolicy();
